import React, { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Menu, Bell, Search } from 'lucide-react';
import Sidebar from '../shared/Sidebar';
import Chatbot from '../shared/Chatbot';
import { useAuth } from '../../hooks/useAuth';
import { Avatar } from '../shared';

export default function DashboardLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { user } = useAuth();

  return (
    <div className="dashboard-layout">
      <Sidebar mobileOpen={mobileOpen} onClose={() => setMobileOpen(false)} />

      <div className="dashboard-main">
        {/* Top bar */}
        <header className="dashboard-topbar">
          <button
            className="btn btn-ghost"
            style={{ display: 'none', padding: 8 }}
            onClick={() => setMobileOpen(true)}
            id="mobile-menu-btn"
          >
            <Menu size={20} />
          </button>

          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ fontFamily: 'var(--font-mono)', fontSize: '0.7rem', color: 'var(--text-muted)', letterSpacing: '0.12em', textTransform: 'uppercase' }}>
              {user?.role} Portal
            </span>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <button className="btn btn-ghost" style={{ padding: 8, position: 'relative' }}>
              <Bell size={18} />
            </button>
            <Avatar name={`${user?.first_name} ${user?.last_name}`} size={32} />
          </div>
        </header>

        {/* Content */}
        <main className="dashboard-content">
          <Outlet />
        </main>
      </div>

      <style>{`
        @media (max-width: 768px) {
          #mobile-menu-btn { display: flex !important; }
        }
      `}</style>
        <Chatbot userRole={user?.role} />
    </div>
  );
}
